import { action } from 'app/actions';

export const GET_SCHOOLS = 'register/GET_SCHOOLS';
export const GET_SCHOOL_DETAILS = 'register/GET_SCHOOL_DETAILS';
export const GET_STATES = 'register/GET_STATES';
export const GET_CITIES = 'register/GET_CITIES';
export const SEARCH_SCHOOLS = 'register/SEARCH_SCHOOLS';
export const REGISTER_USER = 'register/REGISTER_USER';
export const RESET_FORM = 'register/RESET_FORM';
export const COUNTRIES = 'login/COUNTRIES';

export const getSchools = () => action(GET_SCHOOLS);
export const getStates = (idCountry: number) => action(GET_STATES, { payload: { idCountry } });
export const getCities = (idCountry: number, state: string) =>
  action(GET_CITIES, { payload: { state, idCountry } });
export const searchSchools = (idCountry: number, state: string, city: string, keywords: string) =>
  action(SEARCH_SCHOOLS, { payload: { state, idCountry, keywords, city } });
export const getSchoolDetails = (idUserSchool: number) =>
  action(GET_SCHOOL_DETAILS, { payload: { idUserSchool } });
export const registerUser = payload => action(REGISTER_USER, { payload });
export const resetForm = () => action(RESET_FORM); 
export const getCountries = payload => action(COUNTRIES, { payload });
